import { Link, NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isLoggedIn, clearToken, fetchMe } from '@/lib/auth';
import useDocumentMeta from '@/lib/useDocumentMeta';

const ITEMS = [
    { to: '/admin', end: true, label: 'Overview' },
    { to: '/admin/artists', label: 'Artists' },
    { to: '/admin/artworks', label: 'Artworks' },
    { to: '/admin/exhibitions', label: 'Exhibitions' },
    { to: '/admin/journal', label: 'Journal' },
    { to: '/admin/videos', label: 'Films' },
    { to: '/admin/settings', label: 'Site Content' },
    { to: '/admin/enquiries', label: 'Enquiries' },
    { to: '/admin/newsletter', label: 'Newsletter' },
];

export default function AdminLayout() {
    useDocumentMeta({ title: 'Admin · Maison Touré' });
    const nav = useNavigate();
    const [me, setMe] = useState(null);

    useEffect(() => {
        if (!isLoggedIn()) { nav('/admin/login', { replace: true }); return; }
        fetchMe().then(setMe).catch(() => nav('/admin/login', { replace: true }));
    }, [nav]);

    // Escape the public-site image-protection CSS rules while inside the CMS —
    // curators need normal right-click / drag behaviour on images.
    useEffect(() => {
        document.body.classList.add('admin-scope');
        return () => document.body.classList.remove('admin-scope');
    }, []);

    if (!isLoggedIn()) return <Navigate to="/admin/login" replace />;

    return (
        <div data-testid="admin-layout" className="min-h-screen" style={{ background: 'var(--paper)' }}>
            <header className="rule-bottom" style={{ background: 'var(--paper)' }}>
                <div className="container-page flex items-center justify-between py-5">
                    <div className="flex items-center gap-8">
                        <Link to="/" className="wordmark text-xl">Maison Touré</Link>
                        <span className="label" style={{ color: 'var(--clay)' }}>§ Curator's desk</span>
                    </div>
                    <div className="flex items-center gap-6">
                        {me && (
                            <span className="caption hidden md:inline" style={{ fontSize: 13, color: 'var(--ink-3)' }} data-testid="admin-current-user">
                                {me.email}
                            </span>
                        )}
                        <NavLink
                            to="/admin/account"
                            data-testid="admin-account-link"
                            className="label"
                            style={({ isActive }) => ({
                                color: isActive ? 'var(--clay)' : 'var(--ink-2)',
                                paddingBottom: 4,
                                borderBottomWidth: '1px',
                                borderBottomStyle: 'solid',
                                borderBottomColor: isActive ? 'var(--clay)' : 'transparent',
                            })}
                        >
                            Account
                        </NavLink>
                        <button data-testid="admin-logout" onClick={() => { clearToken(); nav('/admin/login'); }} className="label hover:text-[var(--clay)]">Sign out</button>
                    </div>
                </div>
                <div className="container-page flex flex-wrap gap-8 pb-4">
                    {ITEMS.map((i) => (
                        <NavLink key={i.to} to={i.to} end={i.end} data-testid={`admin-tab-${i.label.toLowerCase()}`} className={({ isActive }) => `label ${isActive ? '' : ''}`} style={({ isActive }) => ({ color: isActive ? 'var(--clay)' : 'var(--ink-2)', borderBottomWidth: '1px', borderBottomStyle: 'solid', borderBottomColor: isActive ? 'var(--clay)' : 'transparent', paddingBottom: 4 })}>
                            {i.label}
                        </NavLink>
                    ))}
                </div>
            </header>
            <main className="container-page py-10">
                <Outlet />
            </main>
        </div>
    );
}
